
import { RevButton } from '@ds/components/Button'
import { RevCard } from '@ds/components/Card'
import { RevDivider } from '@ds/components/Divider'
import isEmpty from 'lodash/isEmpty'

import { createObserver } from '@core/helpers/vue-Intersection-observer'
import { trackClick, trackReviewBlockImpression } from '@tracking/events'

import UserComment from '../../UserComment'

export default {
  components: {
    RevButton,
    RevDivider,
    RevCard,
    UserComment,
  },
  props: {
    isMaxReviewsReached: {
      type: Boolean,
      default: false,
    },
    reviews: {
      type: Array,
      required: true,
    },
    buttonLabel: {
      type: String,
      required: true,
    },
    trackingInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  mounted() {
    if (!isEmpty(this.reviews)) {
      this.watchReviewInViewport()
    }
  },
  destroyed() {
    if (typeof this.unobserve === 'function') {
      this.unobserve()
    }
  },
  methods: {
    watchReviewInViewport() {
      this.unobserve = createObserver(this.$el, () => {
        trackReviewBlockImpression(this.trackingInfo)
      })
    },
    clickSeeMoreReviews() {
      trackClick({
        name: 'see_more_reviews',
        pageType: this.$route.name,
      })
      this.$emit('fetch-more')
    },
  },
}
